export var typography = ['Roboto', '"Helvetica"', 'Arial', 'sans-serif'].join(',');
export var typosizing = {
    xs: '8px',
    s: '12px',
    m: '16px',
    l: '24px',
    xl: '36px',
    xxl: '48px',
};
